/*
 ------------------------------------------------------------------
|  Copyright (c) 2015 Izenda, Inc.                                 |
|  ALL RIGHTS RESERVED                                             |
|                                                                  |
|  The entire contents of this file is protected by U.S. and       |
|  International Copyright Laws. Unauthorized reproduction,        |
|  reverse-engineering, and distribution of all or any portion of  |
|  the code contained in this file is strictly prohibited and may  |
|  result in severe civil and criminal penalties and will be       |
|  prosecuted to the maximum extent possible under the law.        |
|                                                                  |
|  RESTRICTIONS                                                    |
|                                                                  |
|  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES           |
|  ARE CONFIDENTIAL AND PROPRIETARY TRADE                          |
|  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS              |
|  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET    |
|  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.                 |
|                                                                  |
|  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED      |
|  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE        |
|  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE       |
|  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT  |
|  AND PERMISSION FROM IZENDA INC.                                 |
|                                                                  |
|  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  |
|  ADDITIONAL RESTRICTIONS.                                        |
 ------------------------------------------------------------------
*/

!(function() {
  var m = require('mobx');
  var SecurityRule = require('./Izenda.SecurityRule');
  var { STATE } = require('logic/data/Izenda.SecurityRulesConstants');
  var { uniqueId, map, uniq, filter, forEach } = require('lodash/fp');

  function SecurityRulesSet(data) {
    var props = {
      tempId: uniqueId('securityRulesSet_'),
      id: null,
      state: STATE.none,
      position: null,
      name: '',
      description: '',
      fields: [],
      rules: [],
      activeRules(){
        return filter(rule => !rule.isDeleted(), this.rules);
      }
    };

    m.extendObservable(this, props);

    data && this.readSecurityRulesList(data);
  }

  SecurityRulesSet.prototype.readSecurityRulesList = m.action(function(data) {
    this.id = data.id;
    this.state = data.state;
    this.position = data.position;
    this.name = data.name;
    this.description = data.description;
    this.fields = data.fields;
    this.rules = data.rules.map(rule => new SecurityRule(rule));
  });

  SecurityRulesSet.prototype.addNewRule = m.action(function() {
    var newRule = new SecurityRule();
    newRule.markAsInserted();
    this.rules.push(newRule);
    this.markAsUpdated();
  });

  SecurityRulesSet.prototype.deleteRule = m.action(function(rule) {
    rule.markAsDeleted();
    this.markAsUpdated();
  });

  SecurityRulesSet.prototype.cloneRule = m.action(function(rule) {
    var clone = rule.clone();
    clone.markAsInserted();
    this.rules.push(clone);
    this.markAsUpdated();
  });

  SecurityRulesSet.prototype.clone = function(saveTempId) {
    var clone = new SecurityRulesSet(m.toJS(this));
    if(saveTempId){
      clone.tempId = this.tempId;
    } else {
      clone.id = null;
      clone.state = STATE.inserted;
      forEach(rule => {
        rule.id = null;
        rule.state = STATE.inserted;
      }, clone.rules);
    }
    return clone;
  };

  SecurityRulesSet.prototype.updateName = m.action(function(name) {
    this.name = name;
    this.markAsUpdated();
  });

  SecurityRulesSet.prototype.updateDescription = m.action(function(description) {
    this.description = description;
    this.markAsUpdated();
  });

  SecurityRulesSet.prototype.updateFields = m.action(function(fields) {
    this.fields = fields;
    this.markAsUpdated();
  });

  SecurityRulesSet.prototype.moveRule = m.action(function(oldPosititon, newPosititon, rule) {
    this.rules.splice(oldPosititon, 1);
    this.rules.splice(newPosititon, 0, rule);
    this.markAsUpdated();
  });

  SecurityRulesSet.prototype.updatePosition = m.action(function(position) {
    this.position = position;
    this.markAsUpdated();
  });

  SecurityRulesSet.prototype.getSelectedQuerySourseFieldIds = function() {
    return map(filed => filed.id, this.fields);
  };

  SecurityRulesSet.prototype.getSelectedQuerySourseIds = function() {
    return uniq(map(filed => filed.querySourceId, this.fields));
  };

  SecurityRulesSet.prototype.markAsUpdated = m.action(function() {
    if(this.state !== STATE.inserted){
      this.state = STATE.updated;
    }
  });

  SecurityRulesSet.prototype.markAsInserted = m.action(function() {
    this.state = STATE.inserted;
  });

  SecurityRulesSet.prototype.markAsDeleted = m.action(function() {
    this.state = STATE.deleted;
  });

  SecurityRulesSet.prototype.isDeleted = function() {
    return this.state === STATE.deleted;
  };

  SecurityRulesSet.prototype.isChanged = function() {
    return this.state === STATE.inserted || this.state === STATE.updated || this.state === STATE.deleted;
  };

  SecurityRulesSet.prototype.getRulesForSaving = function(){
    var rules = [];
    var position = 1;
    forEach(rule => {
      if(!rule.isDeleted()){
        if(rule.position !== position){
          rule.updatePosition(position);
        }
        position += 1;
      }

      // disable because of backend needs
      // if(rule.isChanged())
      rules.push(rule.buildSaveData());

    }, this.rules);
    return rules;
  }

  SecurityRulesSet.prototype.buildSaveData = function() {

    return {
      id: this.id,
      state: this.state,
      position: this.position,
      name: this.name,
      description: this.description,
      fields: this.fields,
      rules: this.getRulesForSaving()
    };
  };

  module.exports = SecurityRulesSet;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.SecurityRulesSet.js